export class OrgCcenter {
    orgElementCode: string;
    orgDescription: string;
    ccenterDescription: string;
    ccenterElementCode: string;

    constructor({
        orgElementCode, orgDescription, ccenterDescription, ccenterElementCode, }: {
            orgElementCode: string;
            orgDescription: string;
            ccenterDescription: string;
            ccenterElementCode: string;
        }) {
        this.orgElementCode = orgElementCode;
        this.orgDescription = orgDescription;
        this.ccenterDescription = ccenterDescription;
        this.ccenterElementCode = ccenterElementCode;
    }
}